import { useCallback } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import reported from 'features/views/productionReport';

const ActionButtons = () => {
	const dispatch = useDispatch();
	const modal = useModal(MODALS.producedProduction_report);

	const handleCancel = useCallback(() => {
		dispatch(modal.hide());
	}, [dispatch, modal]);

	const handleClose = useCallback(() => {
		dispatch(reported.actions.closeProduction());
	}, [dispatch]);

	return (
		<Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
			<Grid size={4}>
				<Button variant="outlined" onClick={handleCancel} fullWidth>
					{getLabelMessage('producedProductionReport:close')}
				</Button>
			</Grid>
			<Grid size={4}>
				<ComponentLoader fetchStorePath={fetch.constants.urls.productionClose} ignoreErrors>
					<Button variant="contained" onClick={handleClose} fullWidth>
						{getLabelMessage('producedProductionReport:closeReportedDocument')}
					</Button>
				</ComponentLoader>
			</Grid>
		</Grid>
	);
};

export default ActionButtons;
